var render = function render(){var _vm=this,_c=_vm._self._c;return _c('string-view',_vm._b({staticClass:"number-view",model:{value:(_vm.formatted),callback:function ($$v) {_vm.formatted=$$v},expression:"formatted"}},'string-view',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }